import React, { useEffect, useRef } from "react";
import { minimapStyles as styles } from './court.tailwind';
import CourtSvg1 from "./CourtSvg1";
import { DEFAULT_H, DEFAULT_W } from "./court.data";

const MinimapComponent = ({ viewBox, scale, onViewBoxChange, hideZoneName }) => {
  const minimapRef = useRef(null);
  const minimapViewportRef = useRef(null);
  const isDragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });

  // In the updateMinimapViewport function in MinimapComponent
  const updateMinimapViewport = () => {
    if (!minimapRef?.current) return;

    const minimapScaleX = minimapRef.current.clientWidth / DEFAULT_W;
    const minimapScaleY = minimapRef.current.clientHeight / DEFAULT_H;

    // Ensure viewbox values are within bounds
    const boundedViewBox = {
      x: Math.max(0, Math.min(DEFAULT_W - viewBox.w, viewBox.x)),
      y: Math.max(0, Math.min(DEFAULT_H - viewBox.h, viewBox.y)),
      w: viewBox.w,
      h: viewBox.h,
    };

    const minimapX = boundedViewBox.x * minimapScaleX;
    const minimapY = boundedViewBox.y * minimapScaleY;
    const minimapW = boundedViewBox.w * minimapScaleX;
    const minimapH = boundedViewBox.h * minimapScaleY;

    if (minimapViewportRef.current) {
      minimapViewportRef.current.style.left = `${minimapX}px`;
      minimapViewportRef.current.style.top = `${minimapY}px`;
      minimapViewportRef.current.style.width = `${Math.min(minimapW, minimapRef.current.clientWidth)}px`;
      minimapViewportRef.current.style.height = `${Math.min(minimapH, minimapRef.current.clientHeight)}px`;
      // minimapViewportRef.current.style.width = `${minimapW}px`;
      // minimapViewportRef.current.style.height = `${minimapH}px`;
    }
  };

  const handleMinimapStart = (e) => {
    isDragging.current = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    dragStart.current = { x: clientX, y: clientY };
  };

  const handleMinimapMove = (e) => {
    if (!isDragging.current) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    const minimapBounds = minimapRef.current.getBoundingClientRect();

    const dx = (clientX - dragStart.current.x) / minimapBounds.width;
    const dy = (clientY - dragStart.current.y) / minimapBounds.height;

    const scaleX = DEFAULT_W / minimapRef.current.clientWidth;
    const scaleY = DEFAULT_H / minimapRef.current.clientHeight;

    const newViewBox = {
      x: Math.max(0, Math.min(DEFAULT_W - viewBox.w, viewBox.x + dx * viewBox.w * scaleX)),
      y: Math.max(0, Math.min(DEFAULT_H - viewBox.h, viewBox.y + dy * viewBox.h * scaleY)),
      w: viewBox.w,
      h: viewBox.h,
    };

    dragStart.current = { x: clientX, y: clientY };

    onViewBoxChange(newViewBox);
  };

  const handleMinimapEnd = () => {
    isDragging.current = false;
  };
  
  useEffect(() => {
    const minimapViewport = minimapViewportRef.current;
    if (!minimapViewport) return;

    const handleMouseUp = () => handleMinimapEnd();

    minimapViewport.addEventListener("mousedown", handleMinimapStart);
    minimapViewport.addEventListener("touchstart", handleMinimapStart);
    window.addEventListener("mousemove", handleMinimapMove);
    window.addEventListener("touchmove", handleMinimapMove);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchend", handleMouseUp);

    return () => {
      minimapViewport.removeEventListener("mousedown", handleMinimapStart);
      minimapViewport.removeEventListener("touchstart", handleMinimapStart);
      window.removeEventListener("mousemove", handleMinimapMove);
      window.removeEventListener("touchmove", handleMinimapMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchend", handleMouseUp);
    };
  }, [viewBox]);

  useEffect(() => {
    updateMinimapViewport();
  }, [viewBox, scale]);

  return (
    <div 
      className={styles.minimapContainer}
      ref={minimapRef}
    >
      <svg
        width={"100%"}
        height={"100%"}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${DEFAULT_W} ${DEFAULT_H}`}
        fill="none"
      >
        <CourtSvg1 hideZoneName={hideZoneName} hideHover={true} />
      </svg>

      <div
        ref={minimapViewportRef}
        className={styles.minimapViewport}
        style={{
          position: "absolute",
          border: "2px solid #ff6347",
          backgroundColor: "rgba(255, 99, 71, 0.3)",
          // pointerEvents: "none", // Prevent interaction with the viewport
          transition: "all 0.2s ease",
        }}
      />
    </div>
  );
};

export default MinimapComponent;
